import { BrandButtonWhite } from "./form/buttons";
import "./appheader.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { AppDataContext, ctxDefinition } from "./ctx";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { usePageVisibility } from "react-page-visibility";
import { ApiEndpoint, checkIfExamComplete, homeUrl } from "./utils";
import { updateCurrentSection } from "./utils";
import NetworkError from "./networkError";
import axios from "axios";

interface Props {
  timer?: boolean;
  checkTimer?: boolean;
  exposeTimer?: ((enabled: boolean) => void) | null;
}

const AppHeader = ({
  timer = true,
  checkTimer = false,
  exposeTimer = null,
}: Props) => {
  const isVisible = usePageVisibility();
  const [minutesRemaining, setMinutesRemaining] = useState(0);
  const [secondsRemaining, setSecondsRemaining] = useState(0);
  const { userData, setUserData, config, examStarted, examType } = useContext(
    AppDataContext
  ) as ctxDefinition;
  const navigate = useNavigate();
  const nextSection = useRef(false);
  const [hasError, setHasError] = useState(false);

  const logout = () => {
    const w: any = window;
    w.location = homeUrl;
  };

  const continueTimeout = async () => {
    if (checkIfExamComplete(userData)) {
      const resp = await axios.post(
        ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
        {
          token: userData.token,
          fields: ["examComplete"],
          values: [true],
        }
      );

      if (!resp || !resp.data.success) {
        setHasError(true);
        return;
      }
      navigate("/exam-complete", { replace: true });
    } else {
      const newTime = new Date().getTime();
      const resp = await axios.post(
        ApiEndpoint + "wp-json/firstchoiceprep/v1/setSectionStartTime",
        {
          token: userData.token,
          sectionId: userData.currentSectionId,
          timestamp: newTime,
          examType: examType,
        }
      );
      if (!resp || !resp.data.success) {
        setHasError(true);
        return;
      }
      const temp = await updateCurrentSection(userData);
      updateRecord(temp);
      setUserData(temp);
      nextSection.current = true;
    }
  };

  const updateRecord = async (uData: any) => {
    const resp = await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: userData.token,
        fields: [
          "currentSectionId",
          "sectionId",
          "currentSection",
          "sectionStartTime",
          "lastQuestionAnswered",
        ],
        values: [
          uData.currentSectionId,
          uData.currentSectionId,
          uData.currentSection,
          uData.sectionStartTime,
          uData.lastQuestionAnswered,
        ],
      }
    );
    if (!resp || !resp.data.success) {
      setHasError(true);
      return;
    }
  };

  const resetSectionTimer = async (time: number) => {
    const reply = await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: userData.token,
        fields: ["sectionStartTime"],
        values: [time],
      }
    );
    if (!reply || !reply.data.success) {
      setHasError(true);
      return;
    }
    const temp = userData;
    temp.sectionStartTime = null;
    setUserData(temp);
  };

  const getRemainigMinutes = () => {
    let timeAlloted =
      examType === 0
        ? config.standardTime[userData.currentSectionId]
        : config.extendedTime[userData.currentSectionId];
    const delta = new Date().getTime() - userData.sectionStartTime;
    const minutes = Math.floor((timeAlloted - delta) / 60 / 1000);
    const seconds = Math.floor(((timeAlloted - delta) / 1000) % 60);
    setMinutesRemaining(minutes);
    setSecondsRemaining(seconds);
  };

  useEffect(() => {
    if (nextSection.current) {
      nextSection.current = false;
      getRemainigMinutes();
      navigate("/section-end/", { replace: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  useEffect(() => {
    if (isVisible && userData && userData.sectionStartTime && timer) {
      let timeAlloted =
        examType === 0
          ? config.standardTime[userData.currentSectionId]
          : config.extendedTime[userData.currentSectionId];
      const delta = new Date().getTime() - userData.sectionStartTime;
      if (delta > timeAlloted) {
        setMinutesRemaining(0);
        setSecondsRemaining(0);
        continueTimeout();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  useEffect(() => {
    if ((userData && userData.sectionStartTime && timer) || checkTimer) {
      let startTime = userData.sectionStartTime;
      if (checkTimer && !startTime) {
        startTime = new Date().getTime();
        resetSectionTimer(startTime);
      }
      let timeAlloted =
        examType === 0
          ? config.standardTime[userData.currentSectionId]
          : config.extendedTime[userData.currentSectionId];
      const timer = setInterval(() => {
        const delta = new Date().getTime() - startTime;
        const minutes = Math.floor((timeAlloted - delta) / 60 / 1000);
        const seconds = Math.floor(((timeAlloted - delta) / 1000) % 60);
        setMinutesRemaining(minutes);
        setSecondsRemaining(seconds);
        if (delta > timeAlloted) {
          clearInterval(timer);
          setMinutesRemaining(0);
          continueTimeout();
        }
      }, 1000);
      return () => {
        clearInterval(timer);
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (exposeTimer){
    exposeTimer(
      minutesRemaining === 0 && secondsRemaining <= 0 ? false : true
    );
  }
  return (
    <div className="exam-header">
      {examStarted && (
        <div className="timer">
          <div className="timer-holder">
            <FontAwesomeIcon icon={faClock} />
            {minutesRemaining < 0 && secondsRemaining < 0 ? (
              <div>... min remaining</div>
            ) : (
              <div>
                {minutesRemaining}:
                {secondsRemaining < 10
                  ? `0${secondsRemaining < 0 ? 0 : secondsRemaining}`
                  : secondsRemaining}{" "}
                min remaining
              </div>
            )}
          </div>
        </div>
      )}
      <BrandButtonWhite onClick={logout} variant="outlined">
        LOGOUT
      </BrandButtonWhite>
      <NetworkError open={hasError} />
    </div>
  );
};

export default AppHeader;
